import {Component, input, output} from "@angular/core";
import {AssessableItem, AssessableItemGroup, Assessment} from "@models";
import {isAssessableGroupActive} from "@common/components/assessment/utils";
import {MatIcon} from "@angular/material/icon";
import {SafeHtmlComponent} from "../../../../shared/shared-components/safe-html/safe-html.component";

export type OnItemClickedData = {
	groupId: string;
	itemId: string;
};

@Component({
	selector: "sim-assessment-exam-index",
	templateUrl: "./assessment-exam-index.component.html",
	styleUrl: "./assessment-exam-index.component.scss",
	imports: [MatIcon, SafeHtmlComponent],
})
export class AssessmentExamIndexComponent {
	protected readonly Array = Array;

	// I/O
	public activeItemId = input.required<string>();
	public activeGroupId = input.required<string>();
	public assessment = input.required<Assessment>();

	public onItemClicked = output<OnItemClickedData>();
	public onGroupClicked = output<string>();

	public isGroupVisible(group: AssessableItemGroup<AssessableItem>): boolean {
		if (group?.items.length === 0) {
			return false;
		}

		return isAssessableGroupActive(group.groupId, this.assessment());
	}
}
